/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UIState {
    sidebar: boolean;
    searchbar: boolean;
    isBody: boolean;
}

const initialState: UIState = {
    sidebar: false,
    searchbar: false,
    isBody: false,
};

const uiSlice = createSlice({
    name: "ui",
    initialState,
    reducers: {
        toggleSidebar(state, action: PayloadAction<{ isOpen?: "open" }>) {
            const {
                payload: { isOpen },
            } = action;
            if (isOpen) {
                state.sidebar = false;
            } else {
                state.sidebar = !state.sidebar;
            }
        },
        toggleSearchbar(state, action: PayloadAction<{ isOpen?: "open" }>) {
            const {
                payload: { isOpen },
            } = action;
            if (isOpen == "open") {
                state.searchbar = false;
            } else {
                state.searchbar = !state.searchbar;
            }
        },
        toggleBody(state) {
            state.isBody = !state.isBody;
        },
    },
});

export const { toggleSidebar, toggleBody, toggleSearchbar } = uiSlice.actions;
export default uiSlice.reducer;
